import { BaseStore } from "../extends/base-store";
import { ImasterContent } from "../interfaces/imaster-content";

export class DeseaDiaVacacionalStore extends BaseStore {
  objValores: Array<ImasterContent> = [];
  /**
   * @author Jose Wilson Mulato
   * @description Obtener valores por defecto de descuento nomina
   */
  protected async GetService() {
    this.objValores = [{ descParametro: 'SI', consParametro: 'SI', valor: 'SI' }, { descParametro: 'NO', consParametro: 'NO', valor: 'NO' }];    
    this.objValores.forEach(x =>
      this.Data.push({ Label: x.descParametro, Value: x.consParametro })
    );
    return;
  }
}



// WEBPACK FOOTER //
// ./src/app/store/deseadiavacacional-store.ts